import { FC, forwardRef, PropsWithChildren, ReactElement, Ref } from "react";
import {
  AppBar,
  Box,
  Dialog,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { Close } from "@mui/icons-material";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<unknown>;
  },
  ref: Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FullScreenDialog: FC<
  PropsWithChildren<{
    show: boolean;
    handleClose: () => void;
    title: string;
    button?: ReactElement;
  }>
> = ({ show, children, handleClose, title, button }) => {
  return (
    <Dialog
      fullScreen
      open={show}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {title}
          </Typography>
          <Box>{button}</Box>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          maxHeight: "100%",
          height: "100%",
          boxSizing: "border-box",
          overflowY: "hidden",
        }}
      >
        {children}
      </Box>
    </Dialog>
  );
};

export default FullScreenDialog;
